<template>
  <div class="SellReportPage page">
    <div class="page-title">
      <span>{{$t('revenue_report')}}</span>
      <div class="choose-currency">
        <select v-if="$route.name !== 'global'" name="currency" v-model="currency" @change="selectCurrency">
          <option v-if="getStoreConfig() && !isNotUseStoreCurrency(getStoreConfig().currency)" :value="null">{{
            getStoreConfig().currency }}</option>
          <option v-for="rate in (getCurrencyRates)" :value="rate.toCurrency" :key="rate.id">
            {{ rate.toCurrency }}
          </option>
        </select>
      </div>
    </div>
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeOutlet="onChangeOutlet"
      @onChangeOrderStatus="onChangeOrderStatus" :disableCompareDate="true" :queryMode="this.query.mode" />
    <UiReportList :reportList="reportList" />
    <UiTableSellReport :report="report" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
import { getItemByLocalStorage, setLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiTableSellReport from '@/components/UiTableSellReport'
import UiReportList from '@/components/UiReportList'
import reportType from '@/config/reportType'
import reportListData from '@/constants/reportList'
export default {
  name: 'SellReportPage',
  components: {
    UiFilterbar,
    UiReportList,
    UiTableSellReport
  },
  data() {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      currency: null,
      day: {},
      query: {
        page: 1,
        limit: 20,
        mode: 'DATETIME',
        outletIds: null,
        timeZone,
        reportingMode: 'in_store'
      },
      filterType: 'DATETIME',
      reportList: reportListData.revenue,
      type: 'products'
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getSellReport',
      getCurrencies: 'currency/getCurrencies',
      getCurrencyRates: 'currency/getCurrencyRates'
    })
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore',
      getCustomStatuses: 'order/getListCustomStatus'
    }),
    selectCurrency() {
      const currencyRate = this.getCurrencyRates.find(rate => rate.toCurrency === this.currency)

      if (currencyRate) {
        const currencySelected = this.getCurrencies.find(currencyItem => this.currency === currencyItem.code)
        const symbol = currencySelected.currency_symbol || this.currency
        var isBaseCurrency = this.getStoreConfig().currency && this.isNotUseStoreCurrency(this.getStoreConfig().currency) && this.currency === this.getStoreConfig().currency
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, { ...currencyRate, symbol, rate: isBaseCurrency ? 1 : currencyRate.rate })
      }

      if (!this.currency && getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
        const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
        const currencySelected = this.getCurrencies.find(currencyItem => storeConfig?.currency === currencyItem.code)
        const symbol = currencySelected.symbol
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
          fromCurrency: storeConfig?.currency,
          toCurrency: storeConfig?.currency,
          rate: 1,
          symbol
        })
      }

      this.getReport({
        type: reportType.products,
        query: {
          ...this.query,
          ...this.day
        }
      })
    },
    getStoreConfig() {
      return getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    },
    onChangeOutlet(reportingMode, outletIds, registerIds, day, type, states) {
      this.day = day
      this.getCustomStatuses()
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.products,
        query: {
          ...this.query,
          ...day,
          states
        }
      })
    },
    onDefaultFilter(day, type, reportingMode, outletIds, registerIds, states) {
      this.day = day
      this.getCustomStatuses()
      if (outletIds) {
        this.query.outletIds = outletIds
        this.query.registerIds = registerIds
      }
      if (reportingMode) {
        this.query.reportingMode = reportingMode
        if (reportingMode === 'online') {
          this.query.outletIds = null
        }
      }
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.products,
        query: {
          ...this.query,
          ...day,
          states
        }
      })
    },
    onChangeOrderStatus(reportingMode, outletIds, registerIds, day, type, states) {
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.products,
        query: {
          ...this.query,
          ...day,
          states
        }
      })
      this.query.showAllOrders = reportingMode !== 'in_store'
      this.getReport({
        type: reportType.products,
        query: {
          ...this.query,
          ...day,
          states,
          mode: null,
          timeZone: this.getTimeZone()
        }
      })
    },
    isNotUseStoreCurrency(currency) {
      if (currency && currency.length && this.getCurrencyRates && this.getCurrencyRates.length > 0) {
        const existCurrency = this.getCurrencyRates.find(currencyItem => currency === currencyItem.toCurrency)
        return !!existCurrency
      }
      return false
    }
  },
  created() {
    if (getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
      this.currency = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY).toCurrency
    } else {
      if (this.getCurrencyRates && this.getCurrencyRates.length > 0) {
        const currencyRate = this.getCurrencyRates[0]
        if (currencyRate) {
          const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
          const currencySelected = this.getCurrencies?.find(currencyItem => storeConfig?.currency === currencyItem.code)
          if (currencySelected) {
            const symbol = currencySelected.symbol
            setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
              fromCurrency: storeConfig?.currency,
              toCurrency: storeConfig?.currency,
              rate: 1,
              symbol
            })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding: 0 30px;
}

.page-title {
  font-size: 36px;
  line-height: 49px;
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;

  select {
    padding: 0 15px;
    margin: 0;
    height: 39px;
    min-width: 140px;
    outline: none;
    border-radius: 4px;
    border: 1px solid #818181;
    background-color: #fff;
  }
}
</style>
